import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import createSubscribeLink from '../../../utils/subscription/createSubscribeLink';
import { logSubscribeActivity } from '../../../actions/logging';

import { USER_REGISTRATION_DIALOG_TEXT } from '../../../constants/localizations/userRegistration';
import { UPSELL_GO_PREMIUM } from '../../../constants/localizations/upsell';
import subscribe from '../../../constants/analytics/categoryActionLabel/subscribe';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import Hint from './Hint';

export class GoPremiumHint extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      logSubscribeActivity: PropTypes.func.isRequired,
    }),
    onGoPremiumClick: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  static contextType = LocationAndLocalizationContext;

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.logSubscribeActivity(
      subscribe.actions.show,
      subscribe.labels.signUpUpsell,
    );
  }

  handleClick() {
    const { actions, onGoPremiumClick } = this.props;
    actions.logSubscribeActivity(
      subscribe.actions.tap,
      subscribe.labels.signUpUpsell,
    );
    onGoPremiumClick();
  }

  render() {
    const { className } = this.props;
    const { getLocalizedText, location } = this.context;
    const source = subscribe.labels.signUpUpsell;
    const subscribeLink = createSubscribeLink({ source, location });

    return (
      <Hint
        className={className}
        text={getLocalizedText(USER_REGISTRATION_DIALOG_TEXT)}
        link={{
          label: getLocalizedText(UPSELL_GO_PREMIUM),
          to: subscribeLink,
          onClick: this.handleClick,
        }}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ logSubscribeActivity }, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(GoPremiumHint);
